import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import Pagination from "../Pagination/Pagination";
import { Link } from "react-router-dom";
import { useQuery } from "react-query";
import { AllItemSort, getPayload } from "../../store/actions";
import axios from "axios";
import endPoints from "../../store/utils/endPoints";
import TableSkeleton from "../Loader/TableSkeleton";
import { numberWithCommas } from "../../utils/misc";
import { isEqual } from "lodash";

const TopCollection = ({ timeFrame }) => {
  const dispatch = useDispatch();
  const { collection } = useSelector((state) => state.nft);
  const [sortField, setSortField] = useState("");
  const [sortType, setSortType] = useState("");
  const [pageNo, setPageNo] = useState(1);
  const [queryParams, setQueryParams] = useState({});

  useEffect(() => {
    if (!collection) {
      setQueryParams({});
      setSortField("");
      setSortType("");
      dispatch(
        getPayload(`${endPoints.allCollection}`, {
          ...queryParams,
          range: timeFrame,
          page: pageNo,
        })
      );
    }
  }, [timeFrame]);

  useEffect(() => {
    if (collection && collection.message) {
      dispatch(
        AllItemSort(
          endPoints.allCollection,
          [...collection.message],
          sortField,
          sortType || false
        )
      );
    }
  }, [queryParams]);

  const handleSortChange = (field, type) => {
    setSortField(field);
    setSortType(type);
    setQueryParams({
      filter_range: timeFrame,
      [field]: type,
    });
  };
  const changePage = useCallback(
    (value) => {
      setPageNo(value);
    },
    [pageNo]
  );

  return (
    <>
      <table className="table">
        <thead>
          <tr>
            <th>Collectiion</th>
            <th
              onClick={() =>
                handleSortChange(
                  "market_cap",
                  sortType === "ASC" ? "DESC" : "ASC"
                )
              }
            >
              Market Cap{" "}
              <i
                className={`fa-solid ${sortField === "market_cap"
                  ? sortType === "DESC"
                    ? "fa-sort-down"
                    : "fa-sort-up"
                  : "fa-sort"
                  }`}
              ></i>
            </th>
            <th
              onClick={() =>
                handleSortChange(
                  "percent_diff",
                  sortType === "ASC" ? "DESC" : "ASC"
                )
              }
            >
              {timeFrame}{" "}
              <i
                className={`fa-solid ${sortField === "percent_diff"
                  ? sortType === "DESC"
                    ? "fa-sort-down"
                    : "fa-sort-up"
                  : "fa-sort"
                  }`}
              ></i>
            </th>
            <th
              onClick={() =>
                handleSortChange(
                  "sales_volume",
                  sortType === "ASC" ? "DESC" : "ASC"
                )
              }
            >
              Sales Volume{" "}
              <i
                className={`fa-solid ${sortField === "sales_volume"
                  ? sortType === "DESC"
                    ? "fa-sort-down"
                    : "fa-sort-up"
                  : "fa-sort"
                  }`}
              ></i>
            </th>
            <th
              onClick={() =>
                handleSortChange(
                  "trade_profit",
                  sortType === "ASC" ? "DESC" : "ASC"
                )
              }
            >
              Trade Profit{" "}
              <i
                className={`fa-solid ${sortField === "trade_profit"
                  ? sortType === "DESC"
                    ? "fa-sort-down"
                    : "fa-sort-up"
                  : "fa-sort"
                  }`}
              ></i>
            </th>
            <th
              onClick={() =>
                handleSortChange(
                  "floor_price",
                  sortType === "ASC" ? "DESC" : "ASC"
                )
              }
            >
              Floor Price{" "}
              <i
                className={`fa-solid ${sortField === "floor_price"
                  ? sortType === "DESC"
                    ? "fa-sort-down"
                    : "fa-sort-up"
                  : "fa-sort"
                  }`}
              ></i>
            </th>
            <th
              onClick={() =>
                handleSortChange("holders", sortType === "ASC" ? "DESC" : "ASC")
              }
            >
              Holders{" "}
              <i
                className={`fa-solid ${sortField === "holders"
                  ? sortType === "DESC"
                    ? "fa-sort-down"
                    : "fa-sort-up"
                  : "fa-sort"
                  }`}
              ></i>
            </th>
            <th
              onClick={() =>
                handleSortChange("buyers", sortType === "ASC" ? "DESC" : "ASC")
              }
            >
              Buyers{" "}
              <i
                className={`fa-solid ${sortField === "buyers"
                  ? sortType === "DESC"
                    ? "fa-sort-down"
                    : "fa-sort-up"
                  : "fa-sort"
                  }`}
              ></i>
            </th>
            <th
              onClick={() =>
                handleSortChange("sellers", sortType === "ASC" ? "DESC" : "ASC")
              }
            >
              Sellers{" "}
              <i
                className={`fa-solid ${sortField === "sellers"
                  ? sortType === "DESC"
                    ? "fa-sort-down"
                    : "fa-sort-up"
                  : "fa-sort"
                  }`}
              ></i>
            </th>
          </tr>
        </thead>

        {!collection ? (
          <tbody>
            <TableSkeleton colSpan={9} />
          </tbody>
        ) : (
          <tbody>
            {collection.message.map((element, index) => {
              return (
                <tr key={element.contract_address}>
                  <td>
                    {/* <div className="token-thumb mr-3">
                       <img
                        src={
                          element?.nft_details?.collection_image_url ??
                          "https://img.cn.cryptokitties.co/0x06012c8cf97bead5deae237070f9587f8e7a266d/14920.svg"
                        }
                        alt="CT"
                      /> 
                    </div> */}
                    <label>
                      {element && element.length ? (
                        element.description.map((item) => {
                          return (
                            <Link
                              key={item.name}
                              to={`/collection/${item?.contract_address || "0"}`}
                            >
                              {item?.name ?? "N/A"}
                            </Link>
                          );
                        })
                      ) : (
                        <Link
                          to={`/collection/${(element.name && element.contract_address) || "0"
                            }`}
                        >
                          {element?.name || "N/A"}
                        </Link>
                      )}
                    </label>
                  </td>
                  <td>{element.market_cap ? element.market_cap : "N/A"}</td>
                  <td className="brand-success">
                    <span
                      className={
                        (element.percent_diff.includes("-") ? `inc` : `dc`) +
                        "Value"
                      }
                    >
                      {element.percent_diff
                        ? (+element.percent_diff).toFixed(2) + "%"
                        : "N/A"}
                    </span>
                  </td>
                  <td className="data-highlight">
                    {element.sales_volume
                      ? numberWithCommas(+element.sales_volume)
                      : "N/A"}
                  </td>
                  <td>
                    {element.trade_profit
                      ? numberWithCommas(+element.trade_profit)
                      : "N/A"}
                    <sub className="brand-success">
                      {element.trade_profit_change}
                    </sub>
                  </td>
                  <td>
                    {element.floor_price
                      ? numberWithCommas(+element.floor_price)
                      : "N/A"}
                  </td>
                  <td>
                    {element.holders
                      ? numberWithCommas(+element.holders)
                      : "N/A"}
                  </td>
                  <td>{element.buyers ? element.buyers : "N/A"}</td>
                  <td>{element.sellers ? element.sellers : "N/A"}</td>
                </tr>
              );
            })}
          </tbody>
        )}
      </table>
      {/* {collection && (
        <Pagination
          totalPages={Math.ceil(collection.Count / collection.ScannedCount)}
          setPage={changePage}
        />
      )} */}
    </>
  );
};

export default React.memo(TopCollection, isEqual);
